import { useAuth } from "../../../contexts/useAuth";
import AdminLayout from "../components/AdminLayout";
import { Users, Activity, TrendingUp, Calendar } from "lucide-react";

export const AdminDashboard = () => {
  const { loginWithGoogle } = useAuth();
  // Mock stats
  const stats = [
    { name: "Total Users", value: "128", icon: Users, change: "+12%" },
    { name: "Active Routines", value: "45", icon: Activity, change: "+5%" },
    {
      name: "Completed Workouts",
      value: "892",
      icon: TrendingUp,
      change: "+24%",
    },
    { name: "Calls Booked", value: "12", icon: Calendar, change: "+2" },
  ];

  return (
    <AdminLayout>
      <div className="mb-8">
        <button onClick={loginWithGoogle}>Login</button>
      </div>

      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {stats.map((stat) => (
          <div
            key={stat.name}
            className="p-6 rounded-xl border border-border bg-card/50 backdrop-blur-sm hover:border-primary/50 transition-colors"
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-muted-foreground">
                  {stat.name}
                </p>
                <p className="text-2xl font-bold mt-2">{stat.value}</p>
              </div>
              <div className="p-3 rounded-lg bg-primary/10 text-primary">
                <stat.icon className="w-6 h-6" />
              </div>
            </div>
            <div className="mt-4 flex items-center text-sm">
              <span className="text-green-500 font-medium">{stat.change}</span>
              <span className="text-muted-foreground ml-2">
                from last month
              </span>
            </div>
          </div>
        ))}
      </div>

      {/* Recent Activity Section */}
      <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="rounded-xl border border-border bg-card/50 p-6">
          <h3 className="text-lg font-semibold mb-4">Recent Activity</h3>
          <div className="space-y-4">
            {[1, 2, 3].map((i) => (
              <div
                key={i}
                className="flex items-center gap-4 py-3 border-b border-border/50 last:border-0"
              >
                <div className="w-2 h-2 rounded-full bg-primary" />
                <div>
                  <p className="text-sm font-medium">New user registered</p>
                  <p className="text-xs text-muted-foreground">2 hours ago</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="rounded-xl border border-border bg-card/50 p-6">
          <h3 className="text-lg font-semibold mb-4">Pending Tasks</h3>
          <div className="space-y-4">
            {/* Placeholder for tasks */}
            <p className="text-muted-foreground text-sm">No pending tasks.</p>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};
